// Delegate clicks so filtering remains usable after Shopify AJAX updates.
document.addEventListener('click', function (event) {
  var toggle = event.target.closest('[data-tw-filter-toggle]');
  if (!toggle) return;
  var bar = toggle.closest('.tw-filter-bar');
  if (!bar) return;
  var expanded = toggle.getAttribute('aria-expanded') !== 'true';
  toggle.setAttribute('aria-expanded', String(expanded));
  bar.classList.toggle('tw-filter-bar--open', expanded);
});

// Fit the slightly larger announcement to the actual font and available width.
(function () {
  function fitAnnouncement() {
    document.querySelectorAll('#site-control .cc-announcement__inner').forEach(function (inner) {
      if (window.innerWidth > 767) { inner.style.removeProperty('font-size'); return; }
      var desired = Math.max(9, Math.min(13, window.innerWidth * 0.0275));
      inner.style.fontSize = desired + 'px';
      var style = window.getComputedStyle(inner);
      var available = inner.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
      var range = document.createRange();
      range.selectNodeContents(inner);
      var width = range.getBoundingClientRect().width;
      if (width > available && available > 0) inner.style.fontSize = (desired * (available - 2) / width) + 'px';
    });
  }
  fitAnnouncement();
  if (document.fonts) document.fonts.ready.then(fitAnnouncement);
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fitAnnouncement, 100);
  });
  document.addEventListener('shopify:section:load', fitAnnouncement);
})();
